import styles from './legalPage.less'; export {styles};

interface LegalPageProps {
    onClickClose: () => void;
}

let _content: string;

export default class LegalPage extends React.Component<LegalPageProps, null> {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (_content) {
            return;
        }

        $j.ajax('/aiti_core/cookiesConsent/legalDetails/').done((data) => {
            _content = data;
            this.forceUpdate();
        });
    }

    render() {
        return (
            <>
                {!_content && (
                    <div className={styles.body}>
                        {_('Please, wait')}
                    </div>
                )}

                {_content && (
                    <div className={styles.body} dangerouslySetInnerHTML={{__html: _content}}/>
                )}

                <div className={styles.buttons}>
                    <div className={classNames(styles.button, styles.conversion)} onClick={() => this.props.onClickClose()}>{_('Back')}</div>
                </div>
            </>
        );
    }
}
